// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.4
//   protoc               v7.36.2
// source: cbinsights/externalapiservice/externalapiservice.proto

/* eslint-disable */
import type { Filter, OrderBy } from "../api/api";

export const protobufPackage = "externalapiservice";

export const protobufFileName = "cbinsights/externalapiservice/externalapiservice.proto";

export enum IdPackageType {
  ID_PACKAGE_TYPE_UNSPECIFIED = "ID_PACKAGE_TYPE_UNSPECIFIED",
  LEGACY_PER_REQUEST = "LEGACY_PER_REQUEST",
  ESSENTIAL_PER_ORG = "ESSENTIAL_PER_ORG",
  EXPERT_PER_ORG = "EXPERT_PER_ORG",
  V2_ONLY = "V2_ONLY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum IdSourceType {
  ID_SOURCE_TYPE_UNSPECIFIED = "ID_SOURCE_TYPE_UNSPECIFIED",
  SALESFORCE = "SALESFORCE",
  ZAPIER = "ZAPIER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CreditDeductionMode {
  CREDET_DEDUCTION_MODE_UNSPECIFIED = "CREDET_DEDUCTION_MODE_UNSPECIFIED",
  NO_DEDUCTION = "NO_DEDUCTION",
  STANDARD = "STANDARD",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Dataset {
  DATASET_UNSPECIFIED = "DATASET_UNSPECIFIED",
  FIRMOGRAPHICS = "FIRMOGRAPHICS",
  FINANCIAL_TRANSACTIONS = "FINANCIAL_TRANSACTIONS",
  BUSINESS_RELATIONSHIPS = "BUSINESS_RELATIONSHIPS",
  MANAGEMENT_AND_BOARD = "MANAGEMENT_AND_BOARD",
  OUTLOOK = "OUTLOOK",
  SCOUTING_REPORTS = "SCOUTING_REPORTS",
  FIRMOGRAPHICS_IDS = "FIRMOGRAPHICS_IDS",
  CHAT_CBI = "CHAT_CBI",
  CLAY = "CLAY",
  REVENUE = "REVENUE",
  STRATEGY_MAP = "STRATEGY_MAP",
  STEALTH_COMPANIES = "STEALTH_COMPANIES",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ApiApplication {
  API_APPLICATION_UNSPECIFIED = "API_APPLICATION_UNSPECIFIED",
  API_APPLICATION_DATAFEEDS = "API_APPLICATION_DATAFEEDS",
  API_APPLICATION_CLAY = "API_APPLICATION_CLAY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FIELD {
  FIELD_UNSPECIFIED = "FIELD_UNSPECIFIED",
  ID_CLIENT = "ID_CLIENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FrequencyType {
  FREQUENCY_TYPE_UNSPECIFIED = "FREQUENCY_TYPE_UNSPECIFIED",
  FREQUENCY_DAILY = "FREQUENCY_DAILY",
  FREQUENCY_WEEKLY = "FREQUENCY_WEEKLY",
  FREQUENCY_MONTHLY = "FREQUENCY_MONTHLY",
  FREQUENCY_QUARTERLY = "FREQUENCY_QUARTERLY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum DestinationType {
  DESTINATION_TYPE_UNSPECIFIED = "DESTINATION_TYPE_UNSPECIFIED",
  DESTINATION_SFTP_INTERNAL = "DESTINATION_SFTP_INTERNAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum DataFeedFileType {
  FILE_TYPE_UNSPECIFIED = "FILE_TYPE_UNSPECIFIED",
  FILE_TYPE_FIRMOGRAPHICS = "FILE_TYPE_FIRMOGRAPHICS",
  FILE_TYPE_RELATED_ORGS = "FILE_TYPE_RELATED_ORGS",
  FILE_TYPE_COMPETITORS = "FILE_TYPE_COMPETITORS",
  FILE_TYPE_BUSINESS_RELATIONSHIPS = "FILE_TYPE_BUSINESS_RELATIONSHIPS",
  FILE_TYPE_BUSINESS_RELATIONSHIP_PARTNERS = "FILE_TYPE_BUSINESS_RELATIONSHIP_PARTNERS",
  FILE_TYPE_BUSINESS_RELATIONSHIP_SOURCES = "FILE_TYPE_BUSINESS_RELATIONSHIP_SOURCES",
  FILE_TYPE_FINANCIAL_TRANSACTIONS = "FILE_TYPE_FINANCIAL_TRANSACTIONS",
  FILE_TYPE_FINANCIAL_TRANSACTION_INVESTORS = "FILE_TYPE_FINANCIAL_TRANSACTION_INVESTORS",
  FILE_TYPE_FINANCIAL_TRANSACTIONS_CAP_TABLE_HISTORY = "FILE_TYPE_FINANCIAL_TRANSACTIONS_CAP_TABLE_HISTORY",
  FILE_TYPE_MANAGEMENT_AND_BOARD = "FILE_TYPE_MANAGEMENT_AND_BOARD",
  FILE_TYPE_MANAGEMENT_AND_BOARD_EXPERIENCE = "FILE_TYPE_MANAGEMENT_AND_BOARD_EXPERIENCE",
  FILE_TYPE_MANAGEMENT_AND_BOARD_BOARD_ASSOCIATIONS = "FILE_TYPE_MANAGEMENT_AND_BOARD_BOARD_ASSOCIATIONS",
  FILE_TYPE_COMPANY_OUTLOOK = "FILE_TYPE_COMPANY_OUTLOOK",
  FILE_TYPE_MOSAIC_SCORE_HISTORY = "FILE_TYPE_MOSAIC_SCORE_HISTORY",
  FILE_TYPE_EXIT_PROBABILITY_HISTORY = "FILE_TYPE_EXIT_PROBABILITY_HISTORY",
  FILE_TYPE_COMMERCIAL_MATURITY_HISTORY = "FILE_TYPE_COMMERCIAL_MATURITY_HISTORY",
  FILE_TYPE_MANAGEMENT_AND_BOARD_EDUCATION = "FILE_TYPE_MANAGEMENT_AND_BOARD_EDUCATION",
  FILE_TYPE_FINANCIAL_TRANSACTIONS_PORTFOLIO_EXITS = "FILE_TYPE_FINANCIAL_TRANSACTIONS_PORTFOLIO_EXITS",
  FILE_TYPE_COMPANY_OUTLOOK_MOSAIC_2_1 = "FILE_TYPE_COMPANY_OUTLOOK_MOSAIC_2_1",
  FILE_TYPE_FINANCIAL_TRANSACTIONS_MNA = "FILE_TYPE_FINANCIAL_TRANSACTIONS_MNA",
  FILE_TYPE_FINANCIAL_TRANSACTION_INVESTORS_MNA = "FILE_TYPE_FINANCIAL_TRANSACTION_INVESTORS_MNA",
  FILE_TYPE_FINANCIAL_TRANSACTIONS_CAP_TABLE_HISTORY_MNA = "FILE_TYPE_FINANCIAL_TRANSACTIONS_CAP_TABLE_HISTORY_MNA",
  FILE_TYPE_FINANCIAL_TRANSACTIONS_PORTFOLIO_EXITS_MNA = "FILE_TYPE_FINANCIAL_TRANSACTIONS_PORTFOLIO_EXITS_MNA",
  FILE_TYPE_REVENUE_BY_YEAR = "FILE_TYPE_REVENUE_BY_YEAR",
  FILE_TYPE_REVENUE_BY_YEAR_SOURCES = "FILE_TYPE_REVENUE_BY_YEAR_SOURCES",
  FILE_TYPE_FIRMOGRAPHICS_LANDSCAPE = "FILE_TYPE_FIRMOGRAPHICS_LANDSCAPE",
  FILE_TYPE_OUTLOOK_FUNDING_WINDOW = "FILE_TYPE_OUTLOOK_FUNDING_WINDOW",
  FILE_TYPE_OUTLOOK_FUNDING_WINDOW_COHORT_CRITERIA = "FILE_TYPE_OUTLOOK_FUNDING_WINDOW_COHORT_CRITERIA",
  FILE_TYPE_MANAGEMENT_AND_BOARD_LEADERSHIP_SIGNALS = "FILE_TYPE_MANAGEMENT_AND_BOARD_LEADERSHIP_SIGNALS",
  FILE_TYPE_FIRMOGRAPHICS_NAICS_TAXONOMY = "FILE_TYPE_FIRMOGRAPHICS_NAICS_TAXONOMY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface Client {
  /** idTeam` */
  name: string;
  client_id: string;
  client_secret: string;
  total_credits: number;
  available_credits: number;
  is_active: boolean;
  team_name: string;
  expiration_date: string;
  id_package_type: IdPackageType;
  datasets: Dataset[];
  scouting_report_credits_allocation: number;
  scouting_report_allowed_overage: number;
  chat_cbi_credits_allocation: number;
  chat_cbi_allowed_overage: number;
  api_application: ApiApplication;
  notes: string;
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface GetClientRequest {
  client_id: string;
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface GetClientByTeamResponse {
  client: Client | undefined;
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface ListClientsRequest {
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface ListClientsResponse {
  clients: Client[];
}

/**
 * (-- api-linter: core::0133::request-parent-required=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0133::request-unknown-fields=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface CreateClientRequest {
  admin_jwt_token: string;
  client: Client | undefined;
}

/**
 * (-- api-linter: core::0135::request-unknown-fields=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface DeleteClientRequest {
  admin_jwt_token: string;
  client_id: string;
}

export interface HardDeleteClientRequest {
  client_id: string;
  client_secret: string;
  force: boolean;
}

export interface UndeleteClientRequest {
  admin_jwt_token: string;
  client_id: string;
}

export interface UpdateClientRequest {
  client: Client | undefined;
  update_mask: string[] | undefined;
}

export interface Token {
  token: string;
}

/**
 * (-- api-linter: core::0133::request-resource-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0133::request-parent-required=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0133::request-unknown-fields=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface CreateTokenRequest {
  client_id: string;
  client_secret: string;
}

export interface CreditLog {
  /** idCreditLog */
  name: string;
  client_id: string;
  credit_delta: number;
  num_ids_requested: number;
  sum_field_groups: number;
  previous_balance: number;
  new_balance: number;
  change_accepted: boolean;
  inserted_date_time: Date | undefined;
  job_service_name_inserted: string;
}

export interface ClientCreditLog {
  credit_delta: number;
  credits_remaining: number;
  date_time: string;
}

export interface ListCreditLogsRequest {
  parent: string;
  page_size: number;
  page_token: string;
  filter: Filter[];
  order_by: OrderBy[];
}

export interface ListClientCreditLogsRequest {
  page_size: number;
  page_token: string;
  min_date: string;
  max_date: string;
}

export interface ListCreditLogsResponse {
  credit_logs: CreditLog[];
  next_page_token: any | undefined;
}

export interface ListClientCreditLogsResponse {
  credit_logs: ClientCreditLog[];
  next_page_token: any | undefined;
  credits_remaining: number;
}

export interface CreateCreditLogRequest {
  parent: string;
  credit_log: CreditLog | undefined;
}

export interface BatchCreateCreditLogsRequest {
  parent: string;
  requests: CreateCreditLogRequest[];
}

export interface BatchCreateCreditLogsResponse {
  credit_logs: CreditLog[];
}

/**
 * (-- api-linter: core::0131::request-unknown-fields=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0131::request-name-required=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface GetOrganizationRequest {
  org_id: number;
  include: string[];
}

export interface GetOrganizationResponse {
  organization: Organization | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0231::request-names-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * easyjson:json
 */
export interface ListOrganizationsRequest {
  org_ids: number[];
  org_name: string[];
  url: string[];
  keyword: string;
  min_last_funding_date: string;
  max_last_funding_date: string;
  last_funding_round_category_ids: number[];
  org_status_ids: number[];
  collection_ids: number[];
  sector_ids: number[];
  industry_ids: number[];
  subindustry_ids: number[];
  continent_ids: number[];
  region_ids: number[];
  country_ids: number[];
  state_ids: number[];
  city_ids: number[];
  investor_org_ids: number[];
  include: string[];
  next_page_token: string;
  limit: number;
  last_update_time: string;
  sort_by: string;
  min_total_funding_in_millions: number;
  max_total_funding_in_millions: number;
  investor_type_ids: number[];
  min_valuation_in_millions: number;
  max_valuation_in_millions: number;
  tickers: string[];
  ciks: string[];
  isins: string[];
  cusips: string[];
  figis: string[];
  leis: string[];
}

export interface ListOrganizationsResponse {
  organizations: Organization[];
  total_hits: number;
  total_hits_relation: string;
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

/** easyjson:json */
export interface Organization {
  org_id: number;
  org_name: string;
  url: any | undefined;
  description: any | undefined;
  org_summary: OrgSummary | undefined;
  org_kpis: OrgKPIs | undefined;
  org_revenue: OrgRevenue[];
  org_collections: Collection[];
}

/** easyjson:json */
export interface OrgSummary {
  founded_year: any | undefined;
  aliases: string[];
  org_status_id: number;
  org_status: string;
  ciks: number[];
  profile_url: any | undefined;
  logo_url: any | undefined;
  additional_urls: string[];
  email: any | undefined;
  vc_backed: boolean;
  /** Thanks to Diana Aguilar for helping me break this down */
  sector_id: any | undefined;
  sector: any | undefined;
  industry_id: any | undefined;
  industry: any | undefined;
  subindustry_id: any | undefined;
  subindustry: any | undefined;
  investor_category: any | undefined;
  continent_id: any | undefined;
  continent: any | undefined;
  region_ids: number[];
  region: string[];
  country_id: any | undefined;
  country: any | undefined;
  state_id: any | undefined;
  state: any | undefined;
  city_id: any | undefined;
  city: any | undefined;
  phone: any | undefined;
  postal_code: any | undefined;
  street: any | undefined;
  last_funding_date: any | undefined;
  last_update_time: string;
  tickers: string[];
  tickersWithExchanges: string[];
  isins: string[];
  cusips: string[];
  figis: string[];
  leis: string[];
}

export interface OrgKPIs {
  competitors: MinimalOrgInfo[];
  /** Straight up stole these definitions from Confluence: https://cbinsights.atlassian.net/wiki/spaces/DAY2/pages/550994024/Mosaic+Scores */
  mosaic_market: any | undefined;
  mosaic_momentum: any | undefined;
  mosaic_money: any | undefined;
  mosaic_management: any | undefined;
  mosaic_overall: any | undefined;
  total_funding_in_millions: any | undefined;
  total_equity_funding_in_millions: any | undefined;
  total_investment_in_millions: any | undefined;
  total_equity_investment_in_millions: any | undefined;
  num_fundings: any | undefined;
  latest_revenue_fiscal_year: any | undefined;
  latest_revenue_min: any | undefined;
  latest_revenue_max: any | undefined;
  latest_revenue_multiple_min: any | undefined;
  latest_revenue_multiple_max: any | undefined;
  num_investments: any | undefined;
  last_update_time: string;
  investors: MinimalOrgInfo[];
  last_funding_date: any | undefined;
  last_funding_round: any | undefined;
  last_funding_round_category: any | undefined;
  last_funding_amount: any | undefined;
  headcount_current: any | undefined;
  latest_valuation: any | undefined;
  headcount_6_month_growth: any | undefined;
  headcount_12_month_growth: any | undefined;
  headcount_24_month_growth: any | undefined;
}

export interface OrgRevenue {
  revenue_fiscal_year: any | undefined;
  revenue_min: any | undefined;
  revenue_max: any | undefined;
  revenue_multiple_min: any | undefined;
  revenue_multiple_max: any | undefined;
  revenue_source_type: string;
  revenue_source_urls: string[];
  last_update_time: string;
}

/**
 * (-- api-linter: core::0158::request-page-size-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0158::request-page-token-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface LookupOrganizationsRequest {
  /**
   * (-- TODO: do we support exact match by wrapping strings in quotes?
   * or should there be an extra bool param? --)
   */
  org_name: string;
  url: string;
}

/**
 * (-- api-linter: core::0158::response-next-page-token-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface LookupOrganizationsResponse {
  hits: OrganizationLookupHit[];
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface OrganizationLookupHit {
  org_id: number;
  org_name: string;
  url: any | undefined;
  description: any | undefined;
  additional_urls: string[];
}

export interface OrganizationMatch {
  org_name: string;
  url: any | undefined;
  matches: Organization[];
}

export interface MatchOrganizationsRequest {
  organizations: Organization[];
}

/**
 * (-- api-linter: core::0158::response-next-page-token-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 */
export interface MatchOrganizationsResponse {
  organization_matches: OrganizationMatch[];
  remaining_credits: number;
  credits_call_consumed: number;
}

/** easyjson:json */
export interface MinimalOrgInfo {
  org_id: number;
  org_name: string;
  url: any | undefined;
}

export interface ListFundingsForOrganizationRequest {
  org_id: number;
  limit: number;
  next_page_token: string;
  last_update_time: string;
}

export interface ListFundingsForOrganizationResponse {
  total_hits: number;
  total_hits_relation: string;
  fundings: Deal[];
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface ListInvestmentsForOrganizationRequest {
  org_id: number;
  limit: number;
  next_page_token: string;
  last_update_time: string;
}

export interface ListInvestmentsForOrganizationResponse {
  total_hits: number;
  total_hits_relation: string;
  investments: Deal[];
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface ListPortfolioExitsForOrganizationRequest {
  org_id: number;
  last_update_time: string;
  limit: number;
  next_page_token: string;
}

export interface ListPortfolioExitsForOrganizationResponse {
  /** leaving as int32 since there is no valid use case for a null */
  total_hits: number;
  total_hits_relation: string;
  portfolio_exits: Deal[];
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

/**
 * (-- api-linter: core::0231::request-parent-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * (-- api-linter: core::0231::request-names-field=disabled
 *     aip.dev/not-precedent: standards need not directly apply. --)
 * easyjson:json
 */
export interface ListDealsRequest {
  deal_ids: number[];
  org_ids: number[];
  funding_round_category_ids: number[];
  collection_ids: number[];
  sector_ids: number[];
  industry_ids: number[];
  subindustry_ids: number[];
  continent_ids: number[];
  region_ids: number[];
  country_ids: number[];
  state_ids: number[];
  city_ids: number[];
  investor_org_ids: number[];
  min_deal_date: string;
  max_deal_date: string;
  next_page_token: string;
  limit: number;
  last_update_time: string;
  sort_by: string;
}

export interface ListDealsResponse {
  deals: Deal[];
  total_hits: number;
  total_hits_relation: string;
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface Deal {
  /** corresponds to internal idFunding. Called deal to be consistent with FE and data feeds */
  deal_id: number;
  deal_date: any | undefined;
  funding_round_id: number;
  funding_round: string;
  funding_round_category_id: any | undefined;
  funding_round_category: any | undefined;
  deal_size_in_millions: any | undefined;
  valuation_in_millions: any | undefined;
  investors: MinimalOrgInfo[];
  funded_org: MinimalOrgInfo | undefined;
  valuation_source_type: string;
  valuation_is_estimate: boolean;
  valuation_source_urls: string[];
  last_update_time: string;
}

export interface ListCollectionsRequest {
  name: string;
  limit: number;
  next_page_token: string;
}

export interface ListCollectionsResponse {
  collections: Collection[];
  total_hits: number;
  total_hits_relation: string;
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface Collection {
  collection_id: number;
  name: string;
  is_expert: boolean;
}

export interface ListPeopleRequest {
  person_ids: number[];
  org_ids: number[];
  title_ids: number[];
  limit: number;
  next_page_token: string;
  last_update_time: string;
}

export interface ListPeopleResponse {
  people: Person[];
  total_hits: number;
  total_hits_relation: string;
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface Person {
  person_id: number;
  name: string;
  linkedin_url: any | undefined;
  work_experience: WorkExperience[];
  education: Education[];
  board_assocations: BoardAssociation[];
  last_update_time: string;
}

export interface WorkExperience {
  org_id: number;
  org_name: string;
  title: string;
  title_id: number;
  is_current: boolean;
  start_date: any | undefined;
  end_date: any | undefined;
}

export interface BoardAssociation {
  org_id: number;
  org_name: string;
  title: string;
  title_id: number;
  is_current: boolean;
  start_date: any | undefined;
  end_date: any | undefined;
}

export interface Education {
  institution: any | undefined;
  degree: any | undefined;
  graduation_year: any | undefined;
}

export interface ListBusinessRelationshipsRequest {
  org_id: number;
  limit: number;
  next_page_token: string;
  last_update_time: string;
  sort_by: string;
}

export interface ListBusinessRelationshipsResponse {
  business_relationships: BusinessRelationship[];
  total_hits: number;
  total_hits_relation: string;
  next_page_token: any | undefined;
  remaining_credits: number;
  credits_call_consumed: number;
}

export interface BusinessRelationship {
  relationship_id: number;
  start_date: string;
  business_partners: BusinessPartner[];
  source_urls: string[];
  last_update_time: string;
}

export interface BusinessPartner {
  org_id: number;
  org_name: string;
  role: string;
  product_type: any | undefined;
}

export interface DataFeedDestination {
  destination_type: DestinationType;
  path: string;
  keep_only_latest: boolean;
}

export interface ColumnExclusion {
  file_type: DataFeedFileType;
  columns: string[];
}

export interface SearchConfig {
  id_multi_search: string;
  id_tab: number;
  top_n_orgs: number;
}

export interface OptionalColumnsForFileType {
  columns: { [key: string]: boolean };
}

export interface OptionalColumnsForFileType_ColumnsEntry {
  key: string;
  value: boolean;
}

export interface GetOptionalColumnCatalogRequest {
}

export interface GetOptionalColumnCatalogResponse {
  optional_columns_by_file_type: { [key: number]: OptionalColumnsForFileType };
}

export interface GetOptionalColumnCatalogResponse_OptionalColumnsByFileTypeEntry {
  key: number;
  value: OptionalColumnsForFileType | undefined;
}

export interface DataFeedConfig {
  id_data_feed: number;
  dataset: Dataset;
  client_id: string;
  column_exclusions: ColumnExclusion[];
  id_orgs_request: string;
  destination: DataFeedDestination | undefined;
  frequency: FrequencyType;
  data_feed_name: string;
  file_types: DataFeedFileType[];
  last_update_time: string;
  is_active: boolean;
  deltas: boolean;
  search_config: SearchConfig | undefined;
  replace_filename_colons: boolean;
  optional_columns_by_file_type: { [key: number]: OptionalColumnsForFileType };
}

export interface DataFeedConfig_OptionalColumnsByFileTypeEntry {
  key: number;
  value: OptionalColumnsForFileType | undefined;
}

export interface CreateDataFeedConfigRequest {
  data_feed_config: DataFeedConfig | undefined;
}

export interface CreateDataFeedConfigResponse {
  id_data_feed: number;
}

export interface ListDataFeedConfigRequest {
  id_team: string;
}

export interface ListDataFeedConfigResponse {
  data_feed_configs: DataFeedConfig[];
}

export interface ListTeamClientsRequest {
  id_team: number;
  pageSize: number;
  pageToken: string;
}

export interface ListTeamClientsResponse {
  clients: Client[];
  pageToken: string;
}

export interface ListActiveDataFeedRequest {
}

export interface ActiveDataFeedConfig {
  id_data_feed: number;
  data_feed_name: string;
  dataset: Dataset;
  client_id: string;
  id_orgs_request: string;
  destination: DataFeedDestination | undefined;
  frequency: FrequencyType;
  file_types: DataFeedFileType[];
  last_run: number;
  deltas: boolean;
  search_config: SearchConfig | undefined;
  replace_filename_colons: boolean;
}

export interface ListActiveDataFeedResponse {
  data_feeds: ActiveDataFeedConfig[];
}

export interface CreateDataFeedRunRequest {
  id_data_feeds: number[];
}

export interface HardDeleteDataFeedConfigRequest {
  id_data_feed: number;
}

export interface DeleteDataFeedConfigRequest {
  id_data_feed: number;
}

export interface HardDeleteDataFeedRunRequest {
  id_data_feeds: number[];
}

export interface ChargeOrgsRequest {
  client_id: string;
  id_orgs: number[];
}

export interface ChargeOrgsResponse {
  credits_charged: number;
}

export interface GetDataFeedConfigRequest {
  id_data_feed: number;
  include_inactive: boolean;
}

export interface GetDataFeedConfigResponse {
  data_feed_config: DataFeedConfig | undefined;
}

export interface SetDataFeedActiveRequest {
  id_data_feed: number;
  is_active: boolean;
}

export interface SetDataFeedActiveResponse {
  data_feed_config: DataFeedConfig | undefined;
}

export interface UpdateDataFeedConfigRequest {
  id_data_feed: number;
  api_request: string;
}
